import { createSelector } from "@reduxjs/toolkit";
import selectDomainGymRaw from "./selectDomainGymRaw";

export default createSelector(selectDomainGymRaw, ({ gym }) => gym);
